// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   کانتینر اصلی
========================= */
.visitors-app {
  background: #ffffff !important;
  height: 100vh;
  width: 100%;
  max-width: 1520px;
  padding: 40px;
  margin: 0 auto;
  box-sizing: border-box;
}

@media (max-width: 1024px) {
  .visitors-app {
    padding: 20px;
  }
}

@media (max-width: 768px) {
  .visitors-app {
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .visitors-app {
    padding: 10px;
  }
}
.tabs {
  display: flex;
  justify-content: space-between; /* دکمه اول چپ، دکمه آخر راست */
  margin-bottom: 2rem;
  box-sizing: border-box;

}


.invoice-details-print {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap; /* ریسپانسیو */
  gap: 12px;
}

.invoice-print-btn-container {
  flex-shrink: 0;
  margin-top: 0;
}

/* موبایل: دکمه زیر details */
@media (max-width: 768px) {
  .invoice-details-print {
    flex-direction: column;
    align-items: flex-start;
  }

  .invoice-print-btn-container {
    margin-top: 12px;
  }

  .invoice-details {
    justify-content: flex-start;
    gap: 20px;
    flex-wrap: wrap;
  }
}

.tabs button {
  padding: 0.6rem 3.8rem;
  border: none;
  border-bottom: 3px solid transparent;
  background-color: #f0f0f0;
  color: #555;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 8px 0 0 0;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.invoice-tab-btn{
    border-radius: 0 8px 0 0 !important;

}

.tabs button:hover {
  background-color: #e0e0e0;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.tabs button.active {
  background-color: #fff;
  border-bottom: 3px solid #ff7a00;
  color: #ff7a00;
  font-weight: 600;
  box-shadow: 0 4px 10px rgba(0,0,0,0.15);
  transform: translateY(-2px);
}

/* =========================
   کارت‌ها
========================= */
.mobile-cards {
  display: block;
  width: 100%;
  padding: 0.5rem 0;
  box-sizing: border-box;
}

.order-card {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  margin-bottom: 1rem;
  cursor: pointer;
  transition: box-shadow 0.3s ease, transform 0.2s ease;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.order-card:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.mobile-card-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1rem 1.5rem;
  font-weight: bold;
  gap: 0.5rem;
  box-sizing: border-box;
}

.header-left {
  flex: 1 1; /* استفاده از کل فضای باقی‌مانده */
  min-width: 0; /* مهم برای text-overflow */
  display: flex;
  align-items: center;
}

.header-left span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 200px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.amount2 {
  font-weight: bold;
  white-space: nowrap;
}

.expand-icon {
  display: inline-block;
  transition: transform 0.3s ease;
  color: #888;
  font-size: 1.2rem;
}

.expand-icon.expanded {
  transform: rotate(180deg);
}

/* بدنه کارت */
.order-card .card-body {
  max-height: 0;
  opacity: 0;
  padding: 0 1.5rem;
  transition: max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1),
              opacity 0.5s ease,
              padding 0.4s ease;
  line-height: 1.6;
  background: #f9f9f9;
  border-top: 1px solid #e5e5e5;
  border-radius: 0 0 8px 8px;
  margin-top: 0;
}

.order-card.expanded .card-body {
  max-height: 500px;
  opacity: 1;
  padding: 1rem 1.5rem;
}

.order-card .card-body div {
  margin-bottom: 0.5rem;
}

`, "",{"version":3,"sources":["webpack://./src/pages/VisitorPage/VisitorPage.css"],"names":[],"mappings":"AAAA;;2BAE2B;AAC3B;EACE,8BAA8B;EAC9B,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,aAAa;EACb,8BAA8B,EAAE,+BAA+B;EAC/D,mBAAmB;EACnB,sBAAsB;;AAExB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe,EAAE,cAAc;EAC/B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,oCAAoC;EACpC,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;IACI,mCAAmC;;AAEvC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;;2BAE2B;AAC3B;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,qDAAqD;EACrD,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,SAAO,EAAE,kCAAkC;EAC3C,YAAY,EAAE,2BAA2B;EACzC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB;;+BAE6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["/* =========================\n   کانتینر اصلی\n========================= */\n.visitors-app {\n  background: #ffffff !important;\n  height: 100vh;\n  width: 100%;\n  max-width: 1520px;\n  padding: 40px;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n\n@media (max-width: 1024px) {\n  .visitors-app {\n    padding: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  .visitors-app {\n    padding: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .visitors-app {\n    padding: 10px;\n  }\n}\n.tabs {\n  display: flex;\n  justify-content: space-between; /* دکمه اول چپ، دکمه آخر راست */\n  margin-bottom: 2rem;\n  box-sizing: border-box;\n\n}\n\n\n.invoice-details-print {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap; /* ریسپانسیو */\n  gap: 12px;\n}\n\n.invoice-print-btn-container {\n  flex-shrink: 0;\n  margin-top: 0;\n}\n\n/* موبایل: دکمه زیر details */\n@media (max-width: 768px) {\n  .invoice-details-print {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .invoice-print-btn-container {\n    margin-top: 12px;\n  }\n\n  .invoice-details {\n    justify-content: flex-start;\n    gap: 20px;\n    flex-wrap: wrap;\n  }\n}\n\n.tabs button {\n  padding: 0.6rem 3.8rem;\n  border: none;\n  border-bottom: 3px solid transparent;\n  background-color: #f0f0f0;\n  color: #555;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border-radius: 8px 0 0 0;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.05);\n}\n\n.invoice-tab-btn{\n    border-radius: 0 8px 0 0 !important;\n\n}\n\n.tabs button:hover {\n  background-color: #e0e0e0;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 10px rgba(0,0,0,0.1);\n}\n\n.tabs button.active {\n  background-color: #fff;\n  border-bottom: 3px solid #ff7a00;\n  color: #ff7a00;\n  font-weight: 600;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.15);\n  transform: translateY(-2px);\n}\n\n/* =========================\n   کارت‌ها\n========================= */\n.mobile-cards {\n  display: block;\n  width: 100%;\n  padding: 0.5rem 0;\n  box-sizing: border-box;\n}\n\n.order-card {\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid #e5e5e5;\n  margin-bottom: 1rem;\n  cursor: pointer;\n  transition: box-shadow 0.3s ease, transform 0.2s ease;\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n}\n\n.order-card:hover {\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\n  transform: translateY(-2px);\n}\n\n.mobile-card-header{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 1rem 1.5rem;\n  font-weight: bold;\n  gap: 0.5rem;\n  box-sizing: border-box;\n}\n\n.header-left {\n  flex: 1; /* استفاده از کل فضای باقی‌مانده */\n  min-width: 0; /* مهم برای text-overflow */\n  display: flex;\n  align-items: center;\n}\n\n.header-left span {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: inline-block;\n  max-width: 200px;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.amount2 {\n  font-weight: bold;\n  white-space: nowrap;\n}\n\n.expand-icon {\n  display: inline-block;\n  transition: transform 0.3s ease;\n  color: #888;\n  font-size: 1.2rem;\n}\n\n.expand-icon.expanded {\n  transform: rotate(180deg);\n}\n\n/* بدنه کارت */\n.order-card .card-body {\n  max-height: 0;\n  opacity: 0;\n  padding: 0 1.5rem;\n  transition: max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1),\n              opacity 0.5s ease,\n              padding 0.4s ease;\n  line-height: 1.6;\n  background: #f9f9f9;\n  border-top: 1px solid #e5e5e5;\n  border-radius: 0 0 8px 8px;\n  margin-top: 0;\n}\n\n.order-card.expanded .card-body {\n  max-height: 500px;\n  opacity: 1;\n  padding: 1rem 1.5rem;\n}\n\n.order-card .card-body div {\n  margin-bottom: 0.5rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
